module.exports = __webpack_public_path__ + "static/media/NorthWestTelegraph-devicecomp-min@2x.2368cc25.webp";